import BaseRetencionInputPipe from './responses/BaseRetencionInputPipe';
import PlataformasTecnologicasResponseInputPipe from './responses/PlataformasTecnologicasResponseInputPipe';
import FideicomisoNoEmpresarialResponseInputPipe from './responses/FideicomisoNoEmpresarialResponseInputPipe';

class ProcessCfdiToJsonInputConversion {
  strategies = {};

  defaults() {
    this.register(new FideicomisoNoEmpresarialResponseInputPipe());
    this.register(new PlataformasTecnologicasResponseInputPipe());
    // No mover esta línea de código *sino debes una pizza
    this.register(new BaseRetencionInputPipe());

    return this;
  }

  register(strategy) {
    this.strategies[strategy.getName()] = strategy;

    return this;
  }

  apply(data) {
    for (const strategy of Object.values(this.strategies)) {
      data = strategy.apply(data);
    }

    return data;
  }

  static make(data) {
    const newThis = new this();

    return newThis.defaults().apply(data);
  }
}

export default ProcessCfdiToJsonInputConversion;
